module.exports = __webpack_public_path__ + "img/message-people-icon.81b2e2fb.svg";